import {
  FollowUpActionStatus,
  IncidentSeverity,
  IncidentStatus,
  TimeSeriesOptions
} from '@lmc/ts-common'
import { getKeys } from './getKeys'

export const incidentReportsTranslations = {
  ACTION_TITLES_REQUIRED: 'Some actions are missing title',
  INCIDENT_REPORTING: 'Incident Reporting',
  INCIDENT_REPORT: 'Incident Report',
  UPDATED_INCIDENT_REPORT_SETTINGS: 'Updated Incident Reports Settings',
  INCIDENT_REPORTING_DESCRIPTION:
    'Here you can add your locations where your {{variable}} usually stay. Later carers can select from these locations when they are recording incidents.',
  SEVERITY_LEVEL_NAMES: 'Severity level names',
  SEVERITY_LEVEL_DESCRIPTION:
    'There are 5 severity levels starting from Level 1 as minor and Level 5 as most major. Incidents that are closed without a case are automatically categorised to Level 1 severity.',
  LEVEL: 'Level',
  ENABLE_LOCATIONS: 'Enable locations',
  INCIDENT_CASE: 'Incident case',
  INCIDENT_DETAILS: 'Incident details',
  SEVERITY: 'Severity',
  OTHER_SERVICE_USERS_INVOLVED: 'Other {{variable}} involved',
  OTHER_PEOPLE_INVOLVED: 'Other people involved',
  OTHER_WITNESS: 'Other witness(es)',
  CARERES_INVOLVED: 'Carers involved',
  RESTRICTIVE_PRACTICES: 'Restrictive practices',
  PHYSICAL_INTERVENTION_APPLIED: 'Physical intervention applied',
  RESTRAINTS_APPLIED: 'Mechanical restraints applied',
  CHEMICAL_RESTRAINTS_APPLIED: 'Chemical restraints applied (PRN)',
  ENVIRONMENTAL_RESTRAINTS_APPLIED: 'Environmental restraints applied',
  VERBAL_RESTRAINTS_APPLIED: 'Verbal restraints applied',
  NO_RESTRICTIVE_PRACTICES_DETAILS: 'No restrictive practices were used',
  INJURIES: 'Injuries',
  INJURIES_OF_RESIDENT: 'Injury of {{variable}}',
  INJURIES_OF_CARERS: 'Injury of Carers',
  INJURIES_OF_OTHER_PARTIES: 'Injury of other parties',
  NO_INJURIES_DETAILS: 'No injuries occurred',
  DAMAGES: 'Damages',
  PROPERTIES_OR_ENV: 'The property or the environment has been damaged',
  DAMAGES_INTRODUCING_RISK_APPLIED:
    'The property or the environment has been damaged and environmental risk has been introduced',
  NO_DAMAGES_DETAILS: 'No damages occurred',
  MEDICATIONS: 'Medications',
  PRN_MEDICATIONS: 'PRN medications administered',
  SU_OPINION: '{{variable}} opinion',
  ADDITIONAL_COMMENT: 'Additional comment',
  ADDITIONAL_COMMENT_REQUIRED:
    'An additional comment is required to close this incident',
  ATTACHMENTS: 'Attachments',
  FILE: 'File',
  IMAGE: 'Image',
  CLICK_TO_UPLOAD: 'Click to Upload',
  FOLLOW_UP_ACTIONS: 'Follow up actions',
  SAFEGUARDING: 'Requires safeguarding',
  SAFEGUARDING_BANNER:
    'Safeguarding items are not available to users without safeguarding access',
  REGULATOR_NOTIFICATION: 'Requires regulator notification',
  ADD_ACTIONS: 'Add actions',
  DEBRIEFING: 'Debriefing',
  NOTES: 'Notes',
  LEARNING_OUTCOMES: 'Learning and outcomes',
  ROOT_CAUSE: 'Root cause of the incident',
  ACTIONS_TAKEN: 'Actions taken to prevent this incident to occur again',
  OTHER_NOTES: 'Other notes',
  ADD_LOCATION: 'Add location',
  SAVE_CHANGES: 'Save changes',
  REVIEW: 'Review',
  CLOSE_INCIDENT: 'Close incident',
  REOPEN_INCIDENT: 'Reopen incident',
  CREATE_CASE: 'Create case',
  EDIT_CASE: 'Edit case',
  CREATING_INCIDENT_CASE: 'Creating Incident Case',
  EDITING_INCIDENT_CASE: 'Editing Incident Case',
  TYPE_HERE: 'Type here...',
  EARLY_ACCESS_TITLE: 'Early Access',
  DISCOVER_NEW_REPORT: 'Discover our new report and share your feedback',
  SHARE_FEEDBACK: 'Share your feedback',
  DOWNLOADING: 'Downloading...',
  EXPORT_CSV: 'Export CSV',
  EMAIL_SENT_TOAST_1: 'An email with the CSV will be sent to',
  EMAIL_SENT_TOAST_2: 'At peak times this may take a while.',
  ADD_ACTION: 'Add Action',

  // logs
  INCIDENT_TYPES: 'Incident Type',
  TITLE: 'Title',
  TITLE_REQUIRED: 'Title is required',
  DESCRIPTION: 'Description',
  DATE_LOGGED: 'Date logged',
  TIME_LOGGED: 'Time logged',
  WITNESSED_BY: 'Witnessed by',
  LOCATION: 'Location',
  LINKED_GOALS: 'Linked goals',
  EDIT: 'Edit',
  DOWNLOAD_PDF: 'Download PDF',
  RESTORE: 'Restore incident',
  RESTORE_MODAL_TITLE: 'Are you sure you want to restore this incident?',
  RESTORE_MODAL_DESCRIPTION:
    'You can remove this incident anytime after it has been restored',
  REOPEN_MODAL_TITLE: 'Are you sure you want to reopen this incident?',
  REOPEN_MODAL_DESCRIPTION:
    'By reopening incident you will overwrite the review date and remove the additional comment left before. These information will remain available in the timeline.',
  LOG: 'Log',
  RECORDED_BY: 'Recorded by',
  CLOSED_BY: 'Closed by',
  CLOSE_COMMENT: 'Close comment',
  REOPENED_BY: 'Reopened by',
  LOGGED_BY: 'Logged by',
  CREATED_BY: 'Created by:',
  GPS_LOCATION: 'GPS Location',
  WHY_CANT_I_SEE_THIS: `Why can't I see this?`,
  UNAVAILABLE: 'Unavailable',
  LOCATION_ACCURACY: 'Location accuracy: within {{accuracy}} meters',
  LATITUDE: 'Latitude:',
  LONGITUDE: 'Longitude:',
  REMOVE: 'Remove',
  REMOVED: 'REMOVED',
  REMOVE_INCIDENT: 'Remove incident',
  REMOVE_MODAL_TITLE: 'Are you sure you want to remove this incident?',
  REMOVE_MODAL_DESCRIPTION:
    'You can restore an incident from the log screen any time.',
  CLOSE_INCIDENT_MODAL_TITLE: 'Are you sure you want to close this incident?',
  CLOSE_INCIDENT_MODAL_DESCRIPTION:
    'By closing this incident you are also marking it as reviewed. You can reopen this incident at any time later on.',
  CLOSE_INCIDENT_MODAL_DESCRIPTION_WITH_CASE:
    'You can reopen this incident at any time later on.',
  FOLLOWING_ACTIONS_NOT_COMPLETED: 'The following actions are not completed:',
  ADD_A_COMMENT: 'Add a comment',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  DETAILS: 'Details',
  ADD: 'Add',
  ADD_BODY_MAPS: 'Add body maps',
  ADD_BODY_MAPS_DESCRIPTION:
    'Add the body maps associated with this incident. Body maps can be created in the Carer App.',
  ADDED_ON: 'Added on',
  ADDING_BODY_MAPS: 'Adding body maps',
  ARE_YOU_SURE_CONTINUE: 'Are you sure you want to continue?',
  /** The rows say "Updated on"; the remove confirmation says "Last updated on". */
  LAST_UPDATED_ON: 'Last updated on',
  YOU_ARE_ABOUT_TO_REMOVE: "You're about to remove:",
  BODY_MAP_ADDED: 'Body map added!',
  BODY_MAP_REMOVED: 'Body map removed!',
  BODY_MAPS_LOAD_FAILED:
    "We couldn't load the body maps. Please refresh the page and try again.",
  NO_BODY_MAPS_AVAILABLE:
    'There are no body maps to add. Body maps can be created in the Carer App.',
  BODY_MAPS_GROUPED_HINT:
    'Body maps may be grouped when they were recorded together as part of the same event.',
  COLLAPSE_BODY_MAP_GROUP: 'Collapse body map group',
  EXPAND_BODY_MAP_GROUP: 'Expand body map group',
  HIDE_DESCRIPTION: 'Hide description',
  INJURY_NOT_YET_RESOLVED: 'Injury not yet resolved',
  INJURY_RESOLVED: 'Injury resolved',
  MULTIPLE_MARKS_AND_INJURIES: 'Multiple marks and injuries ({{count}})',
  RELATED_BODY: 'Related body maps',
  /**
   * Used only by the pre-CM-3533 single-select, kept behind the
   * incident_multiple_body_maps flag. Delete both LEGACY keys with the flag.
   */
  RELATED_BODY_LEGACY: 'Related body map',
  YOU_CAN_SELECT_LEGACY:
    'You can select one of the previously created body maps or take a new one using the carer app and link it to the form later.',
  REMOVING_BODY_MAP: 'Removing body map',
  SHOW_DESCRIPTION: 'Show description',
  SHOW_MORE_BODY_MAPS: 'Show more body maps',
  UPDATED_ON: 'Updated on',
  HANDOVER: 'Handover',
  FLAG_FOR_HANDOVER: 'Flag for handover',
  LOG_NOT_FOUND: 'Log not found',
  CREATE_CASE_INCIDENT_CLOSED:
    'This incident has been closed. Reopen it to create a case.',
  BACK_TO_INCIDENT: 'Back to incident',
  LOG_UPDATED: 'Log updated',
  LOG_REMOVED: 'Log removed',
  LOG_RESTORED: 'Log restored',
  CASE_CREATED: 'Case created',
  INCIDENT_CLOSED: 'Incident closed',
  INCIDENT_REOPENED: 'Incident reopened',
  EMPTY_CASE_TITLE: 'This case has no information entered',
  EMPTY_CASE_DESCRIPTION:
    'Press that blue edit button at the top right of the page to edit this case',
  CASE_UPDATED: 'Case updated',
  [IncidentStatus.needsReview]: 'NEEDS REVIEW',
  [IncidentStatus.open]: 'OPEN',
  [IncidentStatus.closed]: 'CLOSED',
  [`SEVERITY_LEVEL_${IncidentSeverity.level1}`]: 'Minor',
  [`SEVERITY_LEVEL_${IncidentSeverity.level2}`]: 'Moderate',
  [`SEVERITY_LEVEL_${IncidentSeverity.level3}`]: 'Significant',
  [`SEVERITY_LEVEL_${IncidentSeverity.level4}`]: 'Serious',
  [`SEVERITY_LEVEL_${IncidentSeverity.level5}`]: 'Major',
  REQUIRES_SAFEGUARDING: 'Requires safeguarding',
  REQUIRES_REGULATOR_NOTIFICATION: 'Requires regulator notification',
  [FollowUpActionStatus.notStarted]: 'Not started',
  [FollowUpActionStatus.pending]: 'In Progress',
  [FollowUpActionStatus.completed]: 'Completed',
  [FollowUpActionStatus.skipped]: 'Skipped',

  // Dashboard
  DASHBOARD_CARD_TITLE: 'Incidents',
  DASHBOARD_VIEW_ALL: 'View All',
  DASHBOARD_INCIDENTS_30: 'incidents in the last 30 days',
  DASHBOARD_NEEDS_REVIEW: 'Needs review',
  DASHBOARD_OPEN: 'Open cases',
  DASHBOARD_UNRESOLVED: 'Unresolved actions',
  INCIDENTS_DASHBOARD: 'Incidents Dashboard',
  ACTIONS: 'Actions',
  CASES: 'Cases',
  INCIDENTS_TIME: 'Incidents over time',
  TOP_INCIDENTS: 'Top 10 Incident types',
  FILLED_OUT: 'filled out',
  ROOT_CAUSE_PCT: 'Root cause',
  [TimeSeriesOptions.total]: 'Total',
  [TimeSeriesOptions.location]: 'Location',
  [TimeSeriesOptions.incidentType]: 'Incident type',
  [TimeSeriesOptions.severity]: 'Severity',
  NO_FILTERS: 'No filters applied',
  FILTERED_BY: 'Filtered by',
  AND_BY: 'AND by',
  FILTER_DATE: 'Date',
  FILTER_RESIDENTS: 'Residents',
  FILTER_OWNERS: 'Owned by',
  FILTER_SITES: 'Sites',
  FILTER_INCIDENT: 'Incident type',
  FILTER_INCIDENT_CUSTOM: 'Custom',
  FILTER_LOCATION: 'Location',
  FILTER_STATUS: 'Status',
  FILTER_SEVERITY: 'Severity',
  FILTER_RESULT: 'Resulted in',
  TIME: 'Time',
  TOTAL_INCIDENTS: 'Total Incidents',
  TOTAL_COUNT: 'Total Count',
  INCIDENTS: 'Incidents',
  TYPE_OF_INCIDENT: 'Type of Incident',
  NO_DATA: 'Shoot... no data to show you',
  FILLING_CASE_DETAILS: 'To what extent are teams filling out case detail',
  SITE: 'Site',
  INCIDENT_TYPE_CHANGED: 'Incident type changed',
  INCIDENT_TYPE_WARNING:
    "You have edited the incident type. This change will be visible to everyone. Don't forget to update the incident title if you haven't done so already.",
  VIEW_ACTION_TABLE: 'View action table',

  // List
  INCIDENTS_LIST_VIEW: 'Incidents list',
  INCIDENT_TITLE: 'Incident title',
  STATUS: 'Status',
  SEVERITIES: 'Severity',
  RESULTED_IN: 'Resulted in',
  SITES: 'Sites',

  // Action owners
  OWNED_BY: 'Owned by',
  UNASSIGNED: 'Unassigned',
  OWNER: 'Owner',
  ENTER_TITLE: 'Enter title...',
  ACTION: 'Action',

  // Update actions
  INCIDENT_ACTIONS: 'Incident actions',
  UPDATE_STATUS: 'Update Status',
  UPDATE_AN_ACTION: 'Update an action',

  // --- Incident case v2 (incident_case_v2) -----------------------------------
  // Prefixed CASE_V2_ so the nine step tickets add contiguous blocks rather than
  // interleaving with these keys and conflicting on every merge. Step tickets
  // use their own prefix (CASE_V2_INFO_, CASE_V2_IMMEDIATE_, ...).
  CASE_V2_ACTIONS_ADD: 'Add',
  CASE_V2_ACTIONS_ADDING_TITLE: 'Adding action',
  CASE_V2_ACTIONS_ADD_ACTION: 'Add action',
  CASE_V2_ACTIONS_ADD_TEMPLATE: 'Add {{title}}',
  CASE_V2_ACTIONS_CARE_PLAN: 'Care Plan',
  CASE_V2_ACTIONS_COMPLETION_TIME: 'Completion time',
  CASE_V2_ACTIONS_DELETE: 'Delete {{title}}',
  CASE_V2_ACTIONS_DETAILS: 'Action details',
  CASE_V2_ACTIONS_DUE_DATE: 'Due date',
  CASE_V2_ACTIONS_DUE_DATE_HINT:
    'Action owner will be notified when the assigned action becomes overdue.',
  CASE_V2_ACTIONS_DUE_DATE_PLACEHOLDER: 'Select a date',
  CASE_V2_ACTIONS_EDIT: 'Edit {{title}}',
  CASE_V2_ACTIONS_EDITING_TITLE: 'Editing action',
  CASE_V2_ACTIONS_NOT_SET: '-',
  CASE_V2_ACTIONS_OVERDUE: '{{date}} (overdue)',
  CASE_V2_ACTIONS_OWNER: 'Owner',
  CASE_V2_ACTIONS_OWNER_FIELD: 'Assigned owner',
  CASE_V2_ACTIONS_OWNER_HINT:
    "Assign a team member to complete the action. They will be notified when it's assigned.",
  CASE_V2_ACTIONS_STATUS: 'Status',
  CASE_V2_ACTIONS_STATUS_COMPLETED: 'Completed',
  CASE_V2_ACTIONS_STATUS_NOT_STARTED: 'Not started',
  CASE_V2_ACTIONS_STATUS_PENDING: 'In progress',
  CASE_V2_ACTIONS_STATUS_SKIPPED: 'Skipped',
  CASE_V2_ACTIONS_TEMPLATES: 'Template actions',
  CASE_V2_ACTIONS_TEMPLATES_HINT: 'Choose a template to add one quickly.',
  CASE_V2_ACTIONS_TEMPLATE_CARE_PLAN: 'Review and update {{carePlan}}',
  CASE_V2_ACTIONS_TEMPLATE_CARE_PLAN_DETAILS:
    "Update {{name}}'s {{carePlan}} to reflect any new risks identified.",
  CASE_V2_ACTIONS_TEMPLATE_EQUIPMENT_REPLACEMENT: 'Equipment replacement',
  CASE_V2_ACTIONS_TEMPLATE_EQUIPMENT_REPLACEMENT_DETAILS:
    'Order or replace the equipment involved and remove any faulty items from use.',
  CASE_V2_ACTIONS_TEMPLATE_LOCAL_AUTHORITY: 'Notify the local authority',
  CASE_V2_ACTIONS_TEMPLATE_LOCAL_AUTHORITY_DETAILS:
    'Submit a statutory notification to the local authority as required for this type of incident.',
  CASE_V2_ACTIONS_TEMPLATE_NEXT_OF_KIN: 'Notify next of kin',
  CASE_V2_ACTIONS_TEMPLATE_NEXT_OF_KIN_DETAILS:
    'Contact next of kin to inform them of the incident and provide an update.',
  CASE_V2_ACTIONS_TEMPLATE_POLICY_CHANGES: 'Policy changes',
  CASE_V2_ACTIONS_TEMPLATE_POLICY_CHANGES_DETAILS:
    'Review the relevant policy and update it to prevent a recurrence of this incident.',
  CASE_V2_ACTIONS_TEMPLATE_RISK_ASSESSMENTS:
    'Review and update Risk Assessments',
  CASE_V2_ACTIONS_TEMPLATE_RISK_ASSESSMENTS_DETAILS:
    'Revise the relevant risk assessment based on incident findings.',
  CASE_V2_ACTIONS_TEMPLATE_SAFEGUARDING_REFERRAL:
    'Make a safeguarding referral',
  CASE_V2_ACTIONS_TEMPLATE_SAFEGUARDING_REFERRAL_DETAILS:
    'Raise a formal safeguarding referral with the local safeguarding team for investigation.',
  CASE_V2_ACTIONS_TEMPLATE_STAFF_DEBRIEF: 'Debrief with staff involved',
  CASE_V2_ACTIONS_TEMPLATE_STAFF_DEBRIEF_DETAILS:
    'Hold a debrief with staff who were present to review what happened and lessons learned.',
  CASE_V2_ACTIONS_TEMPLATE_STAFF_TRAINING: 'Staff training',
  CASE_V2_ACTIONS_TEMPLATE_STAFF_TRAINING_DETAILS:
    'Arrange or refresh training for staff on the practice or procedure involved in the incident.',
  CASE_V2_ACTIONS_TITLE: 'Action title',
  CASE_V2_ATTACHMENTS: 'Attachments',
  CASE_V2_ATTACHMENTS_DELETE_FAILED:
    "Some files couldn't be removed. Please try again.",
  CASE_V2_ATTACHMENTS_HINT:
    'Add any files or evidence required for this action.',
  CASE_V2_ATTACHMENTS_OPENS_IN_NEW_TAB: 'opens in a new tab',
  CASE_V2_ATTACHMENTS_REMOVE: 'Remove {{name}}',
  CASE_V2_ATTACHMENTS_SAVE_REFUSED:
    "Your changes weren't saved because something you removed still has files attached. Leave this step and come back to try again.",
  CASE_V2_ATTACHMENTS_TOO_LARGE:
    '{{name}} is too large. Files can be up to {{size}} MB.',
  CASE_V2_ATTACHMENTS_TOO_MANY:
    'You can upload up to {{count}} files at a time.',
  CASE_V2_ATTACHMENTS_TYPE_NOT_ALLOWED:
    "{{name}} can't be uploaded. Upload a PDF, Word document, image or email.",
  CASE_V2_ATTACHMENTS_UPLOAD: 'Upload file',
  CASE_V2_ATTACHMENTS_UPLOAD_FAILED:
    "Your changes were saved, but the files couldn't be uploaded. Please try again.",
  CASE_V2_ATTACHMENTS_UPLOAD_SKIPPED:
    "Your changes were saved, but some files weren't uploaded because the actions changed while saving. Check them and try again.",
  CASE_V2_ATTACHMENTS_UPLOAD_TOO_LARGE:
    "Your changes were saved, but a file is larger than {{size}} MB, so the files weren't uploaded.",
  CASE_V2_ATTACHMENTS_UPLOAD_TOO_MANY:
    "Your changes were saved, but only {{count}} files can be uploaded at a time, so the files weren't uploaded.",
  CASE_V2_ATTACHMENTS_UPLOAD_TYPE_NOT_ALLOWED:
    "Your changes were saved, but a file isn't a PDF, Word document, image or email, so the files weren't uploaded.",
  CASE_V2_BACK: 'Back',
  CASE_V2_BACK_TO_INCIDENT_LOG: 'Back to incident log',
  CASE_V2_BACK_TO_INCIDENT_PREVIEW: 'Back to incident preview',
  CASE_V2_CANDOUR_ADD_PERSON: 'Add another person',
  CASE_V2_CANDOUR_APPLICABLE: 'Duty of Candour applicable?',
  CASE_V2_CANDOUR_CLEAR_BODY:
    'Answering No removes the Duty of Candour details recorded for this case when you continue.',
  CASE_V2_CANDOUR_CLEAR_TITLE: 'Remove Duty of Candour details?',
  CASE_V2_CANDOUR_COMMUNICATED_BY: 'Communicated by',
  CASE_V2_CANDOUR_COMMUNICATION_DETAILS: 'Communication details',
  CASE_V2_CANDOUR_COMMUNICATION_NOTES_HINT:
    'Add any additional details about the communication.',
  CASE_V2_CANDOUR_COMPLETED_BY: 'Duty of Candour completed by',
  CASE_V2_CANDOUR_DATE: 'Date',
  CASE_V2_CANDOUR_DATE_COMPLETED: 'Date completed',
  CASE_V2_CANDOUR_DATE_PROVIDED: 'Date provided',
  CASE_V2_CANDOUR_DATE_SHARED: 'Date shared',
  CASE_V2_CANDOUR_DETAILS: 'Details',
  CASE_V2_CANDOUR_KEY_REQUIREMENTS: 'Key requirements met',
  CASE_V2_CANDOUR_METHOD: 'Method',
  CASE_V2_CANDOUR_METHOD_IN_PERSON_MEETING: 'In-person meeting',
  CASE_V2_CANDOUR_METHOD_PHONE: 'Phone',
  CASE_V2_CANDOUR_METHOD_WRITTEN: 'Written',
  CASE_V2_CANDOUR_NOTES: 'Notes',
  CASE_V2_CANDOUR_OTHER: 'Other',
  CASE_V2_CANDOUR_OTHER_METHOD: 'Specify the method',
  CASE_V2_CANDOUR_OUTCOME_NOTES_HINT:
    'Add any additional details about the investigation outcome.',
  CASE_V2_CANDOUR_OUTCOME_SHARED: 'Investigation outcome shared',
  CASE_V2_CANDOUR_PERSON_FAMILY: 'Family/representative',
  CASE_V2_CANDOUR_PERSON_INFORMED: 'Person informed',
  CASE_V2_CANDOUR_PERSON_RESPONSIBLE: 'Person responsible',
  CASE_V2_CANDOUR_PERSON_RESPONSIBLE_HINT:
    'Select a team member responsible for this action.',
  CASE_V2_CANDOUR_PERSON_SERVICE_USER: '{{variable}}',
  CASE_V2_CANDOUR_REQUIREMENT_APOLOGY_PROVIDED: 'Apology provided',
  CASE_V2_CANDOUR_REQUIREMENT_EXPLANATION_GIVEN: 'Explanation given',
  CASE_V2_CANDOUR_REQUIREMENT_SUPPORT_OFFERED: 'Support offered',
  CASE_V2_CANDOUR_REQUIREMENT_WRITTEN_FOLLOW_UP_PROVIDED:
    'Written follow-up provided',
  CASE_V2_CANDOUR_SELECT_ALL_THAT_APPLY: 'Select all that apply.',
  CASE_V2_CANDOUR_TIME: 'Time',
  CASE_V2_CANDOUR_WRITTEN_FOLLOW_UP_CLEAR_BODY:
    'Unticking Written follow-up provided removes its attachments when you continue.',
  CASE_V2_CANDOUR_WRITTEN_FOLLOW_UP_CLEAR_TITLE:
    'Remove written follow-up attachments?',
  CASE_V2_CASE_LOAD_FAILED: 'The incident case could not be loaded.',
  CASE_V2_CLOSE_INCIDENT_NOT_PERMITTED:
    'Only admin or management roles can close cases',
  CASE_V2_CONFIRM_KEEP: 'Keep details',
  CASE_V2_CONFIRM_REMOVE: 'Remove details',
  CASE_V2_CONFIRM_YES_BODY:
    'The details given for No will be removed when you save this step.',
  CASE_V2_CONFIRM_YES_TITLE: 'Remove details?',
  CASE_V2_DRAWER_CANCEL: 'Cancel',
  CASE_V2_DRAWER_CLOSE: 'Close',
  CASE_V2_ENTRY_EDIT: 'Edit',
  CASE_V2_END_TIME: 'End time',
  CASE_V2_FIELD_REQUIRED: 'This field is required.',
  CASE_V2_FINISH: 'Save and exit',
  CASE_V2_IMMEDIATE_ACCIDENT_INCIDENT_RECORD_MADE:
    'Accident / Incident record made',
  CASE_V2_IMMEDIATE_ACTIONS_TAKEN: 'Immediate actions taken',
  CASE_V2_IMMEDIATE_ACTIONS_TAKEN_HINT:
    'Tick everything that was done at the time of the incident.',
  CASE_V2_IMMEDIATE_AMBULANCE_CALLED: 'Ambulance called',
  CASE_V2_IMMEDIATE_CARE_PLAN_CREATED: 'Care Plan created',
  CASE_V2_IMMEDIATE_CARE_PLAN_REVIEWED: 'Care Plan reviewed',
  CASE_V2_IMMEDIATE_CONTACTED_DISTRICT_NURSE: 'Contacted district nurse',
  CASE_V2_IMMEDIATE_CONTACTED_FAMILY: 'Contacted family',
  CASE_V2_IMMEDIATE_CONTACTED_GP: 'Contacted GP',
  CASE_V2_IMMEDIATE_FIRST_AID_GIVEN: 'First aid given',
  CASE_V2_IMMEDIATE_MANAGER_NOTIFIED: 'Manager notified',
  CASE_V2_IMMEDIATE_RISK_ASSESSMENT_CREATED: 'Risk Assessment created',
  CASE_V2_IMMEDIATE_RISK_ASSESSMENT_REVIEWED: 'Risk Assessment reviewed',
  CASE_V2_INFO_CASE_OWNER: 'Case owner',
  CASE_V2_INFO_CASE_OWNER_HINT:
    'The person responsible for following this case through.',
  CASE_V2_INFO_DATE: 'Date',
  CASE_V2_INFO_FLAG_FOR_HANDOVER: 'Flag for handover',
  CASE_V2_INFO_HANDOVER: 'Handover',
  CASE_V2_INFO_INCIDENT_DETAILS: 'Incident details',
  CASE_V2_INFO_INCIDENT_DETAILS_HINT:
    'What was observed, what was said (where relevant) and any environmental factors.',
  CASE_V2_INFO_INCIDENT_SEVERITY: 'Incident severity',
  CASE_V2_INFO_INCIDENT_TIME_AND_DETAILS: 'Incident time & details',
  CASE_V2_INFO_INCIDENT_TYPE: 'Incident type',
  CASE_V2_INFO_LINKED_GOALS: 'Linked goals',
  CASE_V2_INFO_LOCATION: 'Location',
  CASE_V2_INFO_LOGGED_BY: 'Logged by',
  CASE_V2_INFO_LOGGED_TIME: 'Logged time',
  CASE_V2_INFO_REFERENCE_ID: 'Reference ID number',
  CASE_V2_INFO_REFERENCE_ID_HINT: 'Unique ID generated for this incident case.',
  CASE_V2_INFO_TIME: 'Time',
  CASE_V2_INFO_TITLE: 'Title',
  CASE_V2_INJURIES_ADDING_DAMAGES: 'Adding damages',
  CASE_V2_INJURIES_ADDING_OTHER_PARTY: 'Adding other party',
  CASE_V2_INJURIES_ADDING_OTHER_SERVICE_USER: 'Adding other {{variable}}',
  CASE_V2_INJURIES_ADDING_SERVICE_USER_INJURY: "Adding {{variable}}'s injury",
  CASE_V2_INJURIES_ADDING_TEAM_MEMBER: 'Adding team member',
  CASE_V2_INJURIES_ADD_DAMAGES: 'Add damages',
  CASE_V2_INJURIES_ADD_INJURY: 'Add injury',
  CASE_V2_INJURIES_ADD_OTHER_SERVICE_USER: 'Add other {{variable}}',
  CASE_V2_INJURIES_ADD_PARTY: 'Add party',
  CASE_V2_INJURIES_ADD_SERVICE_USER_INJURIES: "Add {{variable}}'s injuries",
  CASE_V2_INJURIES_ADD_TEAM_MEMBER: 'Add team member',
  CASE_V2_INJURIES_BODY_MAPS_BACK: 'Back',
  CASE_V2_INJURIES_BODY_MAP_NOT_FOUND: 'Body map not found',
  CASE_V2_INJURIES_BODY_MAPS_LOADING: 'Loading body maps',
  CASE_V2_INJURIES_BODY_MAPS_NOT_LOADED: "Body maps couldn't be loaded",
  CASE_V2_INJURIES_BY_WHOM: 'By whom',
  CASE_V2_INJURIES_CHOOSE_PERSON: 'Choose who was injured',
  CASE_V2_INJURIES_DAMAGE_DETAILS_HINT:
    'Describe the damages and how it happened.',
  CASE_V2_INJURIES_DAMAGE_NO_CONFIRM_BODY:
    'The damages recorded for this incident will be removed when you save this step.',
  CASE_V2_INJURIES_DAMAGE_NO_CONFIRM_TITLE: 'Remove damages?',
  CASE_V2_INJURIES_DAMAGE_ONLY: 'Damage only, no ongoing danger',
  CASE_V2_INJURIES_DAMAGE_TYPE: 'Damage type',
  CASE_V2_INJURIES_DELETE: "Delete {{name}}'s injury",
  CASE_V2_INJURIES_DELETE_DAMAGE: 'Delete {{damage}}',
  CASE_V2_INJURIES_DETAILS: 'Details',
  CASE_V2_INJURIES_EDIT: "Edit {{name}}'s injury",
  CASE_V2_INJURIES_EDIT_DAMAGE: 'Edit {{damage}}',
  CASE_V2_INJURIES_EDITING_DAMAGES: 'Editing damages',
  CASE_V2_INJURIES_EDITING_INJURY: 'Editing injury',
  CASE_V2_INJURIES_INJURY_DETAILS_HINT:
    'Describe the cause, nature of the injury, and how it happened.',
  CASE_V2_INJURIES_NAME: 'Name',
  CASE_V2_INJURIES_NO_CONFIRM_BODY:
    'The injuries recorded for this incident will be removed when you save this step.',
  CASE_V2_INJURIES_NO_CONFIRM_TITLE: 'Remove injuries?',
  CASE_V2_INJURIES_ONGOING_HAZARD:
    "Damage created an ongoing safety or environmental hazard. Something was damaged, and it's now created a safety risk",
  CASE_V2_INJURIES_OTHER_PARTIES: 'Other parties',
  CASE_V2_INJURIES_OTHER_SERVICE_USERS: 'Other {{variable}}',
  CASE_V2_INJURIES_OTHER_SERVICE_USER_BANNER_BODY:
    "Create a separate log for each {{variable}}'s injuries.",
  CASE_V2_INJURIES_OTHER_SERVICE_USER_BANNER_TITLE:
    "Injuries added here won't create a separate incident log.",
  CASE_V2_INJURIES_RELATED_BODY_MAPS: 'Related body maps',
  CASE_V2_INJURIES_RELATED_BODY_MAPS_HINT:
    'Add the relevant body maps created in the Carer App.',
  CASE_V2_INJURIES_SERVICE_USER: 'The {{variable}}',
  CASE_V2_INJURIES_TEAM_MEMBERS: 'Team members',
  CASE_V2_INJURIES_TREATMENT: 'Treatment',
  CASE_V2_INJURIES_TREATMENT_GIVEN: 'Treatment given',
  CASE_V2_INJURIES_TREATMENT_HINT:
    'Enter the name of the medicine, dressing, or equipment.',
  CASE_V2_INJURIES_UNNAMED: 'Unnamed person',
  CASE_V2_INJURIES_WAS_ANYONE_INJURED: 'Was anyone injured?',
  CASE_V2_INJURIES_WAS_ANYTHING_DAMAGED: 'Was anything damaged?',
  CASE_V2_INJURIES_WHAT_WAS_DAMAGED: 'What was damaged?',
  CASE_V2_INVESTIGATION_ATTENDEES: 'Attendees',
  CASE_V2_INVESTIGATION_COLD_DEBRIEF: 'Cold debrief (follow-up)',
  CASE_V2_INVESTIGATION_COMPLETED_DATE: 'Completed date',
  CASE_V2_INVESTIGATION_CONTRIBUTING_FACTORS: 'Contributing factors',
  CASE_V2_INVESTIGATION_CONTRIBUTING_FACTORS_HINT:
    'Identify all relevant influences. Select all that apply.',
  CASE_V2_INVESTIGATION_DEBRIEF_NO_CONFIRM_BODY:
    'Unticking this removes the debriefs recorded for this case when you save this step.',
  CASE_V2_INVESTIGATION_DEBRIEF_NO_CONFIRM_TITLE: 'Remove debriefs?',
  CASE_V2_INVESTIGATION_DEBRIEFS: 'Hot and cold debriefs',
  CASE_V2_INVESTIGATION_DEBRIEF_REQUIRED: 'Debrief required?',
  CASE_V2_INVESTIGATION_DEBRIEF_UNTICK_CONFIRM_BODY:
    'Unticking this removes the details recorded for this debrief when you save this step.',
  CASE_V2_INVESTIGATION_DEBRIEF_UNTICK_CONFIRM_TITLE: 'Discard these details?',
  CASE_V2_INVESTIGATION_EXPLANATION: 'Explanation',
  CASE_V2_INVESTIGATION_EXPLANATION_HINT:
    'Explain how the selected factors contributed.',
  CASE_V2_INVESTIGATION_FACTOR_COMMUNICATION: 'Communication',
  CASE_V2_INVESTIGATION_FACTOR_COMPETENCY: 'Competency',
  CASE_V2_INVESTIGATION_FACTOR_CULTURE: 'Culture',
  CASE_V2_INVESTIGATION_FACTOR_DISTRACTIONS: 'Distractions',
  CASE_V2_INVESTIGATION_FACTOR_DOCUMENTATION: 'Documentation',
  CASE_V2_INVESTIGATION_FACTOR_EQUIPMENT_FAILURE: 'Equipment failure',
  CASE_V2_INVESTIGATION_FACTOR_EQUIPMENT_UNAVAILABLE: 'Equipment unavailable',
  CASE_V2_INVESTIGATION_FACTOR_FATIGUE: 'Fatigue',
  CASE_V2_INVESTIGATION_FACTOR_GROUP_ENVIRONMENT: 'Environment',
  CASE_V2_INVESTIGATION_FACTOR_GROUP_EQUIPMENT: 'Equipment',
  CASE_V2_INVESTIGATION_FACTOR_GROUP_ORGANISATION: 'Organisation',
  CASE_V2_INVESTIGATION_FACTOR_GROUP_PEOPLE: 'People',
  CASE_V2_INVESTIGATION_FACTOR_GROUP_PROCESS: 'Process',
  CASE_V2_INVESTIGATION_FACTOR_HANDOVER_FAILURES: 'Handover failures',
  CASE_V2_INVESTIGATION_FACTOR_KNOWLEDGE: 'Knowledge',
  CASE_V2_INVESTIGATION_FACTOR_MAINTENANCE_ISSUES: 'Maintenance issues',
  CASE_V2_INVESTIGATION_FACTOR_NOISE: 'Noise',
  CASE_V2_INVESTIGATION_FACTOR_PHYSICAL_LAYOUT: 'Physical layout',
  CASE_V2_INVESTIGATION_FACTOR_POLICIES: 'Policies',
  CASE_V2_INVESTIGATION_FACTOR_POOR_PROCEDURES: 'Poor procedures',
  CASE_V2_INVESTIGATION_FACTOR_ROSTERING: 'Rostering',
  CASE_V2_INVESTIGATION_FACTOR_STAFFING_LEVELS: 'Staffing levels',
  CASE_V2_INVESTIGATION_FACTOR_SUPERVISION: 'Supervision',
  CASE_V2_INVESTIGATION_FACTOR_TRAINING: 'Training',
  CASE_V2_INVESTIGATION_FACTOR_UNCLEAR_RESPONSIBILITIES:
    'Unclear responsibilities',
  CASE_V2_INVESTIGATION_FACTOR_WORKLOAD: 'Workload',
  CASE_V2_INVESTIGATION_HOT_DEBRIEF: 'Hot debrief (immediate)',
  CASE_V2_INVESTIGATION_IMMEDIATE_CAUSE: 'Immediate cause',
  CASE_V2_INVESTIGATION_IMMEDIATE_CAUSE_HINT:
    'What directly led to the incident? Use <fiveWhysLink>the 5 whys technique</fiveWhysLink> to uncover underlying causes.',
  CASE_V2_INVESTIGATION_IMMEDIATE_LEARNING: 'Immediate learning',
  CASE_V2_INVESTIGATION_IMMEDIATE_LEARNING_HINT:
    'How was the incident handled, what was learned, and how do the people involved feel now?',
  CASE_V2_INVESTIGATION_IMPROVEMENT_ACTIONS: 'Improvement actions',
  CASE_V2_INVESTIGATION_LEARNING_IDENTIFIED: 'Learning identified',
  CASE_V2_INVESTIGATION_LESSONS_IDENTIFIED: 'Lessons identified',
  CASE_V2_INVESTIGATION_LESSONS_IDENTIFIED_HINT:
    'Describe organisational learning. For example, improve medication escalation procedures.',
  CASE_V2_INVESTIGATION_OPENS_IN_NEW_TAB: 'opens in a new tab',
  CASE_V2_INVESTIGATION_ROOT_CAUSE_ANALYSIS: 'Root cause analysis',
  CASE_V2_INVESTIGATION_SERVICE_USER_OPINION: "{{serviceUser}}'s opinion",
  CASE_V2_INVESTIGATION_SERVICE_USER_OPINION_HINT:
    "The {{serviceUser}}'s views about what happened and how it affected them. Where possible, record their own words rather than an interpretation.",
  CASE_V2_LOG_UPDATE_BODY:
    'Some of the information you changed is also part of the incident log. Continuing will update the incident log with your changes.',
  CASE_V2_LOG_UPDATE_CANCEL: 'Cancel',
  CASE_V2_LOG_UPDATE_CONTINUE: 'Save and continue',
  CASE_V2_LOG_UPDATE_EXPORTED:
    'If you have already exported the incident log, the information in that copy may be different from the updated version.',
  CASE_V2_LOG_UPDATE_QUESTION:
    'Would you like to save the changes and continue?',
  CASE_V2_LOG_UPDATE_TITLE: 'Updating the incident log',
  CASE_V2_NAME: 'Name',
  CASE_V2_NAME_OF_ROW: 'Name of {{label}} {{number}}',
  CASE_V2_NEXT: 'Save and next',
  CASE_V2_NO: 'No',
  CASE_V2_PDF_FILE_NAME: '{{reference}} {{title}}',
  CASE_V2_PDF_GENERATED: 'Generated {{date}}',
  CASE_V2_PDF_PAGE: 'Page {{page}}',
  CASE_V2_PDF_TITLE: 'Incident: {{type}}',
  CASE_V2_PEOPLE_ADD_OTHER_SERVICE_USER: 'Add other {{variable}}',
  CASE_V2_PEOPLE_ADD_PARTY: 'Add party',
  CASE_V2_PEOPLE_ADD_TEAM_MEMBER: 'Add team member',
  CASE_V2_PEOPLE_ADD_WITNESS: 'Add witness',
  CASE_V2_PEOPLE_OTHER_PARTIES: 'Other parties involved',
  CASE_V2_PEOPLE_OTHER_SERVICE_USER: 'Other {{variable}}',
  CASE_V2_PEOPLE_OTHER_SERVICE_USERS: 'Other {{variable}} involved',
  CASE_V2_PEOPLE_TEAM_MEMBER: 'Team member',
  CASE_V2_PEOPLE_TEAM_MEMBERS: 'Team members involved',
  CASE_V2_PEOPLE_WITNESSES: 'Witnesses',
  CASE_V2_NOTIFICATIONS_CQC: 'CQC notified',
  CASE_V2_NOTIFICATIONS_DISCARD_BODY:
    'Unticking this removes the details recorded for it when you save.',
  CASE_V2_NOTIFICATIONS_DISCARD_TITLE: 'Discard these details?',
  CASE_V2_NOTIFICATIONS_ENQUIRY_CLOSED_AT: 'Date closed',
  CASE_V2_NOTIFICATIONS_ENQUIRY_CLOSED_AT_BEFORE_SUBMITTED:
    "The date closed can't be before the submitted date.",
  CASE_V2_NOTIFICATIONS_ENQUIRY_CLOSED_AT_FUTURE:
    "The date closed can't be in the future.",
  CASE_V2_NOTIFICATIONS_ENQUIRY_LOCAL_AUTHORITY: 'Local authority',
  CASE_V2_NOTIFICATIONS_ENQUIRY_OUTCOME: 'Enquiry outcome',
  CASE_V2_NOTIFICATIONS_ENQUIRY_OUTCOME_ALL: 'All concerns upheld',
  CASE_V2_NOTIFICATIONS_ENQUIRY_OUTCOME_NONE: 'No concerns upheld',
  CASE_V2_NOTIFICATIONS_ENQUIRY_OUTCOME_RECOMMENDATION:
    'Outcome and recommendation',
  CASE_V2_NOTIFICATIONS_ENQUIRY_OUTCOME_SOME: 'Some concerns upheld',
  CASE_V2_NOTIFICATIONS_ENQUIRY_TYPE: 'Enquiry type',
  CASE_V2_NOTIFICATIONS_ENQUIRY_TYPE_HINT:
    'For example, Section 42, Adult Protection and Support Order (APSO), Statutory Inquiry, or Adult Protection Procedures.',
  CASE_V2_NOTIFICATIONS_FAMILY: 'Family/representative informed',
  CASE_V2_NOTIFICATIONS_LOCAL_AUTHORITY: 'Local authority informed',
  CASE_V2_NOTIFICATIONS_MANAGER: 'Manager informed',
  CASE_V2_NOTIFICATIONS_NOTIFIED_BY: 'Notified by',
  CASE_V2_NOTIFICATIONS_NOTIFIED_DATE: 'Notified date',
  CASE_V2_NOTIFICATIONS_POLICE: 'Police informed',
  CASE_V2_NOTIFICATIONS_PROGRESSED_TO_ENQUIRY: 'Progressed to an enquiry',
  CASE_V2_NOTIFICATIONS_REFERENCE_NUMBER: 'Reference number',
  CASE_V2_NOTIFICATIONS_RIDDOR: 'RIDDOR submitted',
  CASE_V2_NOTIFICATIONS_SAFEGUARDING: 'Safeguarding referral submitted',
  CASE_V2_NOTIFICATIONS_SUBMITTED_BY: 'Submitted by',
  CASE_V2_NOTIFICATIONS_SUBMITTED_DATE: 'Submitted date',
  CASE_V2_REMOVE: 'Remove',
  CASE_V2_REMOVE_ROW: 'Remove {{label}} {{number}}',
  CASE_V2_REQUIRED_FIELDS_HINT: 'Required fields are marked with',
  CASE_V2_RESTRICTIVE_ADD: 'Add restrictive practice',
  CASE_V2_RESTRICTIVE_ADDING: 'Adding restrictive practice',
  CASE_V2_RESTRICTIVE_ANY_USED: 'Any restrictive practices used?',
  CASE_V2_RESTRICTIVE_DE_ESCALATION:
    'De-escalation techniques attempted before this intervention?',
  CASE_V2_RESTRICTIVE_DE_ESCALATION_SUMMARY:
    'De-escalation techniques attempted',
  CASE_V2_RESTRICTIVE_DELETE: 'Delete {{practice}}',
  CASE_V2_RESTRICTIVE_DETAILS: 'Details',
  CASE_V2_RESTRICTIVE_DURATION: 'Duration',
  CASE_V2_RESTRICTIVE_DURATION_RANGE: '{{start}} – {{end}}',
  CASE_V2_RESTRICTIVE_EDIT: 'Edit {{practice}}',
  CASE_V2_RESTRICTIVE_EDITING: 'Editing restrictive practice',
  CASE_V2_RESTRICTIVE_INTERVENTION_PLANNED:
    'This was pre-planned in a Care Plan or Positive Behaviour Support (PBS) plan',
  CASE_V2_RESTRICTIVE_INTERVENTION_TYPE: 'Intervention type',
  CASE_V2_RESTRICTIVE_INTERVENTION_UNPLANNED:
    'It was an unplanned emergency response',
  CASE_V2_RESTRICTIVE_METHOD: 'Restraint method',
  CASE_V2_RESTRICTIVE_METHOD_FLOOR_RESTRAINT: 'Floor restraint',
  CASE_V2_RESTRICTIVE_METHOD_GUIDING_OR_ESCORTING: 'Guiding/escorting',
  CASE_V2_RESTRICTIVE_METHOD_HOLDING: 'Holding',
  CASE_V2_RESTRICTIVE_METHOD_MECHANICAL_RESTRAINT: 'Mechanical restraint',
  CASE_V2_RESTRICTIVE_METHOD_OTHER: 'Other restrictive physical intervention',
  CASE_V2_RESTRICTIVE_METHOD_PROTECTIVE_OR_DEFENSIVE:
    'Protective/defensive intervention',
  CASE_V2_RESTRICTIVE_METHOD_SEATED_RESTRAINT: 'Seated restraint',
  CASE_V2_RESTRICTIVE_METHOD_STANDING_RESTRAINT: 'Standing restraint',
  CASE_V2_RESTRICTIVE_NO_CONFIRM_BODY:
    'The restrictive practices recorded for this incident will be removed when you save this step.',
  CASE_V2_RESTRICTIVE_NO_CONFIRM_TITLE: 'Remove restrictive practices?',
  CASE_V2_RESTRICTIVE_NOTES: 'Notes',
  CASE_V2_RESTRICTIVE_NOTES_HINT:
    'Additional details about this restrictive practice.',
  CASE_V2_RESTRICTIVE_OUTCOME: 'Outcome',
  CASE_V2_RESTRICTIVE_OUTCOME_CALMED_AND_ENDED_SAFELY:
    'The person became calmer and the restrictive practice was ended safely',
  CASE_V2_RESTRICTIVE_OUTCOME_DAMAGE_TO_PROPERTY:
    'Any damage to property or environment',
  CASE_V2_RESTRICTIVE_OUTCOME_FOLLOW_UP_ACTIONS:
    'Any follow-up actions, such as debriefing, notifying family or guardians, reviewing the care plan, or reporting to relevant authorities',
  CASE_V2_RESTRICTIVE_OUTCOME_HINT:
    'What happened as a result of using the restrictive practice.',
  CASE_V2_RESTRICTIVE_OUTCOME_INJURIES_OR_DISTRESS:
    'Any injuries or distress experienced by the person, staff, or others',
  CASE_V2_RESTRICTIVE_OUTCOME_MEDICAL_ASSESSMENT:
    'Medical assessment or treatment was required',
  CASE_V2_RESTRICTIVE_OUTCOME_NO_INJURIES:
    'The person or others sustained no injuries',
  CASE_V2_RESTRICTIVE_OUTCOME_RETURNED_TO_USUAL_ACTIVITIES:
    'The person returned to their usual activities after the incident',
  CASE_V2_RESTRICTIVE_OUTCOME_RISK_REDUCED:
    'The immediate risk was reduced or prevented',
  CASE_V2_RESTRICTIVE_PRACTICE_REQUIRED:
    'Add at least one restrictive practice.',
  CASE_V2_RESTRICTIVE_REASON: 'Reason for use',
  CASE_V2_RESTRICTIVE_REASON_HINT:
    'Describe the immediate, serious risk of harm that made the restriction necessary.',
  CASE_V2_RESTRICTIVE_TYPE: 'Type of restrictive practice',
  CASE_V2_RESTRICTIVE_TYPE_CHEMICAL_RESTRAINT:
    'Chemical restraints applied (PRN)',
  CASE_V2_RESTRICTIVE_TYPE_ENVIRONMENTAL_RESTRAINT:
    'Environmental restraints applied',
  CASE_V2_RESTRICTIVE_TYPE_MECHANICAL_RESTRAINT:
    'Mechanical restraints applied',
  CASE_V2_RESTRICTIVE_TYPE_PHYSICAL_INTERVENTION:
    'Physical intervention applied',
  CASE_V2_RESTRICTIVE_TYPE_VERBAL_RESTRAINT: 'Verbal restraints applied',
  CASE_V2_SAVE: 'Save',
  CASE_V2_SAVE_FAILED: 'Your changes could not be saved. Please try again.',
  CASE_V2_SELECT_PLACEHOLDER: 'Select option…',
  CASE_V2_SELECT_PLACEHOLDER_MULTI: 'Select options…',
  CASE_V2_SERVICE_USER_DETAILS: '{{variable}} details',
  CASE_V2_SERVICE_USERS: 'Service users',
  CASE_V2_START_TIME: 'Start time',
  CASE_V2_STEPPER_LABEL: 'Incident case steps',
  CASE_V2_STEPPER_STEP_COMPLETED: '{{step}} (completed)',
  CASE_V2_STEP_DUTY_OF_CANDOUR: 'Duty of Candour',
  CASE_V2_STEP_DUTY_OF_CANDOUR_SUBTITLE:
    'Keep the person affected informed. Record what was communicated, when, the apology given, and any follow-up.',
  CASE_V2_STEP_FOLLOW_UP_ACTIONS: 'Follow-up actions',
  CASE_V2_STEP_FOLLOW_UP_ACTIONS_SUBTITLE:
    'Add actions to manage risks, support those involved, and prevent the issue from happening again.',
  CASE_V2_STEP_IMMEDIATE_ACTIONS: 'Immediate actions',
  CASE_V2_STEP_IMMEDIATE_ACTIONS_SUBTITLE:
    'Record the immediate steps taken to keep everyone safe.',
  CASE_V2_STEP_INCIDENT_INFORMATION: 'Incident information',
  CASE_V2_STEP_INCIDENT_INFORMATION_SUBTITLE:
    'Provide details about the incident, include the incident date, time, location, type, and severity.',
  CASE_V2_STEP_INJURIES_AND_DAMAGES: 'Injuries & damages',
  CASE_V2_STEP_INJURIES_AND_DAMAGES_SUBTITLE:
    'Record any injuries, harm, or damage caused by the incident.',
  CASE_V2_STEP_INVESTIGATION: 'Investigation',
  CASE_V2_STEP_INVESTIGATION_SUBTITLE:
    'Understand what caused the incident and what we can learn from it.',
  CASE_V2_STEP_NOTIFICATIONS: 'Notifications',
  CASE_V2_STEP_NOTIFICATIONS_SUBTITLE:
    'Record who was informed and any required regulatory notifications.',
  CASE_V2_STEP_NOT_BUILT_YET: 'This step is not built yet.',
  CASE_V2_STEP_PEOPLE_INVOLVED: 'People involved',
  CASE_V2_STEP_PEOPLE_INVOLVED_SUBTITLE:
    'Add anyone directly involved in or who witnessed the incident.',
  CASE_V2_STEP_RESTRICTIVE_PRACTICES: 'Restrictive practices',
  CASE_V2_STEP_RESTRICTIVE_PRACTICES_SUBTITLE:
    'Only complete this section if a restrictive practice was used.',
  CASE_V2_SU_ADDRESS: 'Address',
  CASE_V2_SU_DATE_OF_BIRTH: 'Date of birth',
  CASE_V2_SU_DATE_OF_BIRTH_AGE: '{{date}} ({{age}})',
  CASE_V2_SU_LOAD_FAILED: '{{variable}} details could not be loaded.',
  CASE_V2_SU_NHS_NUMBER: 'NHS number',
  CASE_V2_SU_NOT_RECORDED: 'N/A',
  CASE_V2_SU_PREFERRED_NAME: '{{name}} ({{preferredName}})',
  CASE_V2_SU_SEX: 'Sex',
  CASE_V2_TRY_AGAIN: 'Try again',
  CASE_V2_VIEW_ACTIONS_ACTION: 'Action {{number}}: {{title}}',
  CASE_V2_VIEW_ACTIONS_DETAILS: 'Details',
  CASE_V2_VIEW_BODY_MAP_NOT_FOUND: 'Body map not found',
  CASE_V2_VIEW_BODY_MAP_UNTITLED: 'Untitled body map',
  CASE_V2_VIEW_CANDOUR_COMPLETED_BY: 'Duty of Candour completed by',
  CASE_V2_VIEW_CANDOUR_FAMILY_NAMED: '{{name}} (Family/representative)',
  CASE_V2_VIEW_CANDOUR_OTHER_METHOD: 'Other: {{method}}',
  CASE_V2_VIEW_CANDOUR_OTHER_NAMED: '{{name}} (Other)',
  CASE_V2_VIEW_INCIDENT_DATE: 'Incident date',
  CASE_V2_VIEW_INCIDENT_DESCRIPTION: 'Incident description',
  CASE_V2_VIEW_INCIDENT_LOCATION: 'Incident location',
  CASE_V2_VIEW_INCIDENT_TIME: 'Incident time',
  CASE_V2_VIEW_INJURIES_DAMAGE: 'Damage {{number}}',
  CASE_V2_VIEW_INJURIES_OTHER_PARTY: 'Other party {{number}}',
  CASE_V2_VIEW_INJURIES_OTHER_SERVICE_USER: 'Other {{variable}} {{number}}',
  CASE_V2_VIEW_INJURIES_TEAM_MEMBER: 'Team member {{number}}',
  CASE_V2_VIEW_INVESTIGATION_DEBRIEF_REQUIRED: 'Debrief required',
  CASE_V2_VIEW_LOGGED_DATE: 'Logged date',
  CASE_V2_VIEW_LOGGED_TIME: 'Logged time',
  CASE_V2_VIEW_LOG_DETAILS: 'Log details',
  CASE_V2_VIEW_NOT_LOADED: "Couldn't be loaded",
  CASE_V2_VIEW_PEOPLE_SERVICE_USER: '{{variable}} involved',
  CASE_V2_VIEW_PREFERRED_NAME: '{{name}} ({{preferredName}})',
  CASE_V2_VIEW_RESTRICTIVE_DETAILS: 'Details',
  CASE_V2_VIEW_RESTRICTIVE_PRACTICE: 'Restrictive practice {{number}}',
  CASE_V2_VIEW_RESTRICTIVE_TYPE: 'Restrictive practice type',
  CASE_V2_VIEW_SERVICE_USER: 'Service user',
  CASE_V2_VIEW_SERVICE_USER_NOT_FOUND: '{{variable}} not found',
  CASE_V2_VIEW_STATUS: 'Status',
  CASE_V2_VIEW_STATUS_CLOSED: 'Closed',
  CASE_V2_VIEW_STATUS_NEEDS_REVIEW: 'Needs review',
  CASE_V2_VIEW_STATUS_OPEN: 'Open',
  CASE_V2_VIEW_TEAM_MEMBER_NOT_FOUND: 'Team member not found',
  CASE_V2_VIEW_TIME_RANGE: '{{start}} – {{end}}',
  CASE_V2_YES: 'Yes'
}

export const incidentReportsConstants = getKeys(incidentReportsTranslations)
